import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { StyledDescriptionBlock, StyledTitle } from './ProductDetailStyles'
import ProductGalleryModal from '../ProductGallery/ProductGalleryModal'
import SafelySetInnerHTML from '../SafelySetInnerHTML'

const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  margin-top: 16px;
`
const ImageColumn = styled.div`
  flex: 1;
  min-width: 250px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const ImageItem = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  cursor: zoom-in;
`

const TextColumn = styled.div`
  flex: 1;
  min-width: 300px;
  color: #475569;
  line-height: 1.6;
`

const ProductDetailBlock = ({ article, additionalImages = [], withTitle }) => {
  const [openGalleryModal, setOpenGalleryModal] = useState(null)
  const { t } = useTranslation()

  return (
    <StyledDescriptionBlock>
      {withTitle && (
        <StyledTitle className='h1 mb-4'>
          {t('productDetail:productDetails')}
        </StyledTitle>
      )}

      <ContentWrapper>
        {additionalImages.length > 0 && (
          <ImageColumn>
            {additionalImages.map((img, index) => (
              <ImageItem
                key={index}
                src={img.url}
                alt=''
                onClick={() => setOpenGalleryModal({ startIndex: index })}
              />
            ))}
          </ImageColumn>
        )}

        <TextColumn>
          {article.additionalInfo.split('\n').map((s, i) => (
            <div key={i} className='mb-1'>
              <SafelySetInnerHTML>{s}</SafelySetInnerHTML>
            </div>
          ))}
        </TextColumn>
      </ContentWrapper>

      {openGalleryModal && (
        <ProductGalleryModal
          startIndex={openGalleryModal.startIndex}
          handleClose={() => setOpenGalleryModal(null)}
          detailImages={additionalImages}
        />
      )}
    </StyledDescriptionBlock>
  )
}

export default ProductDetailBlock
